import * as React from "react";
import { useState } from "react";
import { Modal } from "../Modal";
import "./style.css";

import { useMediaQuery } from "react-responsive";
import { Typography, Box } from "@mui/material";

const ModalContent = (props) => {
    const { title, subtitle, open, selectedImage, isSurvey, children } = props;
    const [openImageModal, setOpenImageModal] = useState(open);

    const [displayImages, setDisplayImages] = useState(false);
    const [displayModalContent, setDisplayModalContent] = useState(false);

    const isDesktop = useMediaQuery({ minWidth: 1180 });
    const md = useMediaQuery({ minWidth: 900 });
    const sm = useMediaQuery({ maxWidth: 767 });

    React.useEffect(() => {
        console.log("openImageModal :: " + openImageModal);
        setTimeout(() => {
            setDisplayModalContent(true);
        }, 200);
    }, []);

    /*const handleCloseModal = () => {
    setDisplayModalContent(false);
   
    setTimeout(() => {
      setOpenImageModal(false);
    }, 500);
    props.openModal(false);
  };*/

    const handleCloseModal = (value) => {
        setDisplayModalContent(false);
        setTimeout(() => {
            setOpenImageModal(false);
        }, 500);
        props.openModal(false);
    };

    return (
        <Modal
            open={openImageModal}
            title=""
            onClose={() => {
                handleCloseModal();
            }}
            fullScreen={true}
            maxWidth="lg"
            hideActions={true}
            hideTitle={true}>
            {isSurvey ? (
                <Box
                    sx={{
                        height: "100vh",
                        textAlign: "center",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                    }}>
                    {children}
                </Box>
            ) : (
                <div style={{ padding: sm ? "1rem" : "0" }}>
                    <div className="cms-hm-image-wrapper">
                        <img
                            alt={selectedImage?.title}
                            loading="lazy"
                            src={`${selectedImage?.originalImg}`}
                            sizes="100vw"
                            srcSet={`${selectedImage?.originalImg} 500w, ${selectedImage?.originalImg} 800w, ${selectedImage?.originalImg} 1080w, ${selectedImage?.originalImg} 1446w`}
                            className={`cms-hm-image modal-fade-in ${displayModalContent ? "show" : ""}`}></img>
                    </div>
                    <div
                        class="wrapper"
                        style={{
                            color: "white",
                            height: sm ? "auto" : "100vh",
                            display: "flex",
                            alignItems: "center",
                            maxWidth: "83.5rem",
                        }}>
                        <div class="w-layout-grid grid _3-col">
                            <div id="w-node-dd04497d-d57c-4279-a799-d26e6aca4f2f-64103116">
                                {title}
                                {subtitle}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Modal>
    );
};

export { ModalContent };
